import { useEffect, useState } from "react";
import { $parse } from "../state";

/**
 * Used to get the permission for UI elements
 * @returns True or False
 */
export function useUIPermission(permissions: string[], and?: boolean) {
  const [found, setFound] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState<number>(0);

  // Calling the state function
  useEffect(() => {
    setLoading(true);

    $parse.ui.checkPermissionForUser(permissions, and).then((result) => {
      setFound(result);
      setLoading(false);
    });

    return () => {};
  }, [reload]);

  return {
    loading: loading,
    found: found,
    reload: () => setReload((prev) => prev + 1),
  };
}
